var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBareX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.2083H2.375L8.20061 11.3604L12.6667 18.2083H16.8123H18L17.3593 17.2083L11.3104 7.76777L18.2083 0H15.8333L10.3636 6.29015L6.33333 0H1.98554H0.791667L1.44384 1L7.2381 9.88452L0 18.2083ZM7.92031 9.09998L2.63771 1H5.78641L9.67983 7.07653L16.1716 17.2083H13.2084L7.92031 9.09998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBareX);
export default __webpack_public_path__ + "static/media/bare-x.d7ddd3af37a390e28ce8306124db7b71.svg";
export { ForwardRef as ReactComponent };